<template>
  <div>
    <div class="mx-auto pb-16 max-w-screen-lg">
      <div class="pt-10 px-4 grid grid-cols-3 gap-3">
        <div class="col-span-3 md:col-span-2">
          <portal-billing-collect-payment-method-card />
        </div>
        <div class="col-span-3 md:col-span-1">
          <div class="mx-auto rounded p-6 bg-white border sm:h-full md:h-auto">
            <div class="font-bold text-gray-800">Merchant details</div>
            <div class="mt-3 text-gray-800">
              {{ companyName }}
            </div>
          </div>
          <div
            class="text-gray-400 text-xs mt-3"
            v-if="viewportWidth >= 768"
          >
            <ion-icon name="lock-closed-outline" />
            Your payment information is protected and kept confidential.
          </div>
        </div>
      </div>
      <div
        class="text-gray-400 text-xs mt-3 w-full text-center"
        v-if="viewportWidth < 768"
      >
        <ion-icon name="lock-closed-outline" />
        Your payment information is protected and kept confidential. Powered by Rainforest
      </div>
    </div>
  </div>
</template>

<script>
import PortalBillingCollectPaymentMethodCard from "../components/payment_methods/PortalBillingCollectPaymentMethodCard.vue"
import PortalMerchantDetailCard from "../../ClientPortal/components/invoice_payment/PortalMerchantDetailCard.vue"

export default {
  name: "PortalBillingPaymentMethods",

  components: {
    PortalMerchantDetailCard,
    PortalBillingCollectPaymentMethodCard,
  },

  data() {
    return {
      viewportWidth: window.innerWidth,
      company: window.FinancialCents.company || null,
    }
  },

  computed: {
    companyName() {
      return this.company?.name
    },
  },

  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize)
  },

  unmounted() {
    window.removeEventListener("resize", this.handleResize)
  },
}
</script>
